import api from './api.ts';

export enum AircraftStatus {
  IN_STOCK = 'in_stock',
  SOLD = 'sold',
  RESERVED = 'reserved',
}

export type AircraftCategory = 'airplane' | 'helicopter' | 'other';

export interface Aircraft {
  id: number;
  make: string;
  model: string;
  year: number;
  tailNumber: string;
  color: string;
  purchasePrice: number;
  sellingPrice: number | null;
  status: AircraftStatus;
  category?: AircraftCategory;
  purchaseDate: string;
  soldDate?: string | null;
  assetId?: number | null;
  notes?: string | null;
  attachments?: any[];
  createdAt?: string;
  updatedAt?: string;
}

export interface AircraftPayload {
  make: string;
  model: string;
  year: number;
  tailNumber: string;
  color: string;
  purchasePrice: number;
  sellingPrice: number | null;
  category?: AircraftCategory;
  purchaseDate: string;
  soldDate?: string | null;
  assetId?: number | null;
  notes?: string | null;
  attachments?: any[];
}

export const AircraftsAPI = {
  list: async (): Promise<Aircraft[]> => {
    const res = await api.get('/aircrafts');
    return res.data;
  },
  get: async (id: number): Promise<Aircraft> => {
    const res = await api.get(`/aircrafts/${id}`);
    return res.data;
  },
  create: async (payload: AircraftPayload): Promise<Aircraft> => {
    const res = await api.post('/aircrafts', payload);
    return res.data;
  },
  update: async (id: number, payload: Partial<AircraftPayload>): Promise<Aircraft> => {
    const res = await api.put(`/aircrafts/${id}`, payload);
    return res.data;
  },
  delete: async (id: number): Promise<{ deleted: boolean }> => {
    const res = await api.delete(`/aircrafts/${id}`);
    return res.data;
  },
  sell: async (
    id: number,
    saleData: { sellingPrice: number; soldDate?: string }
  ): Promise<Aircraft> => {
    const res = await api.put(`/aircrafts/${id}/sell`, saleData);
    return res.data;
  },
  history: async (id: number): Promise<any[]> => {
    const res = await api.get(`/aircrafts/${id}/history`);
    return res.data;
  },
};
